import { render, staticRenderFns } from "./DialogRemove.vue?vue&type=template&id=f259a3bc"
import script from "./DialogRemove.vue?vue&type=script&lang=js"
export * from "./DialogRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports